import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { LoginOldApiService } from './login-old-api.service';

@Injectable()
export class HttpCredentialsInterceptor implements HttpInterceptor {
  constructor(
    private loginOldApiService: LoginOldApiService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
        withCredentials: true
    });

    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.loginOldApiService.logOut();
          }
          return throwError(error);
        })
      );
  }
}
